<div class="flex flex-1 px-12 mobile:px-0 py-4 bg-primary-500 items-center mobile:flex-col"
  *ngIf="footer$|async as footer">
  <div class="flex flex-1  items-center mobile:justify-center mobile:pb-3 w-full">
    <app-logo></app-logo>
  </div>
  <div class="flex flex-1 flex-col items-center justify-center text-white w-full">
    <ng-container *ngIf="footer.ubicacion">
      <div class="flex flex-1 justify-start space-x-2 cursor-pointer items-center mobile-flex-adjustment"
        (click)="openMap()">
        <span class="text-sm mobile-text-adjustment text-center text-white font-bold">
          Dirección: {{footer.ubicacion}}
        </span>
      </div>
    </ng-container>
    <ng-container *ngIf="footer.telefono">
      <div class="flex flex-1 justify-start space-x-2 items-center mobile-flex-adjustment">
        <span class="text-sm text-white font-bold mobile-text-adjustment">
          Teléfono: {{footer.telefono}}
        </span>
      </div>
    </ng-container>
    <div class="flex flex-1 justify-start space-x-2 items-center mobile-flex-adjustment">
      <span class="text-base text-white font-bold mobile-text-adjustment">
        Email: {{footer.contacto}}
      </span>
    </div>

    <div class="flex flex-1 flex-row items-center my-1 justify-center text-white w-full">
      <a class="mx-2" *ngIf="footer.whatsapp;" [routerLink]="['https://www.whatsapp.com/']"
        routerLinkActive="router-link-active" (click)="goWhatsapp(footer.whatsapp)">
        <fa-icon class="text-2xl" [icon]="faWhatsapp"></fa-icon>
      </a>
      <a class="mx-2" *ngIf="footer.facebook;" [href]="'https://www.facebook.com' + footer.facebook">
        <fa-icon class="text-2xl" [icon]="faFacebook"></fa-icon>
      </a>
      <a class="mx-2" *ngIf="footer.instagram;" [href]="'https://www.instagram.com' + footer.instagram">
        <fa-icon class="text-2xl" [icon]="faInstagram"></fa-icon>
      </a>
      <a class="mx-2" *ngIf="footer.twitter;" [href]="'https://www.twitter.com' + footer.twitter">
        <fa-icon class="text-2xl" [icon]="faTwitter"></fa-icon>
      </a>
      <a class="mx-2" *ngIf="footer.youtube;" [href]="'https://www.youtube.com' + footer.youtube">
        <fa-icon class="text-2xl" [icon]="faYoutube"></fa-icon>
      </a>
    </div>
  </div>
  <div class="flex flex-1 flex-col items-end justify-center">
    <div class="flex flex-1 justify-end mt-4">
      <a href="https://red-i.com.ar/v2/home">
        <img src="assets/Red-I-footer.png" class="img-footer-ri">
      </a>
    </div>
    <div class="flex flex-1 justify-end mt-4 div-kozaca">
      <a href="https://www.kozaca.com.ar/">
        <img src="assets/kozaca.png" class="img-footer-kzc">
      </a>
    </div>
  </div>
</div>

<div class="flex flex-1 justify-start space-x-2 items-center bg-primary-500 mobile-flex-adjustment">
  <span class="text-sm text-white font-bold mobile:text-xs">
    Build: {{version}}
  </span>
</div>
